<template>
  <Timeline class="study-wrap">
    <TimelineItem v-for="(item, index) in catalogList" :key="index">
      <span class="item-dot" slot="dot">
        <span></span>
      </span>
      <div class="study-title" @click="setVisible(item)" v-if="item.cate_childs.length > 0">
        <div v-if="!item.visible" class="title-icon">
          <i class="el-icon-circle-plus-outline" style="font-size: 16px;"></i>
        </div>
        <div v-else class="title-icon">
          <i class="el-icon-remove-outline" style="font-size: 16px;"></i>
        </div>

        <div class="title-text">
          {{ item.title }}
        </div>
      </div>
      <div v-else class="study-title study-body">
        <div class="study-item" style="width: 100%; border:0;">
          <div class="title-text title-text1">
            {{ item.title }}
          </div>
          <div class="progress">
            <div class="progress-title">练习进度</div>
            <div class="progress-bar">
              <Progress :percent="item.percent" hide-info :stroke-width="8"
                :stroke-color="['#27a4ff', '#227efa']" />
            </div>
            <div class="progress-text">
              {{ item.cont }}/{{ item.totality }}
            </div>
          </div>
          <div class="action">
            <router-link :to="{
                name: 'Paper',
                params: { id: item.id},
                query: { cid: item.category_id, type_id: item.type_id }
              }"><Button type="primary" shape="circle" long>开始练习</Button></router-link>
              <router-link :to="{
                name: 'WrongBook',
                params: { sid: item.id },
                query: { cid: item.category_id }
                }">
                <Button class="error-btn" type="default" shape="circle" long>错题：{{item.error_count?item.error_count:0}}</Button>
              </router-link>
          </div>
        </div>
      </div>
      <transition-group name="slide-up" v-if="item.cate_childs.length > 0">
        <div v-show="item.visible" v-for="item1 in item.cate_childs" :key="item1.id" @click="setVisible(item1)">
          <div v-if="item1.cate_childs.length > 0">
            <div class="study-title" style="padding: 20px 0 13px 0; margin-left: 20px;">
              <div v-if="!item1.visible" class="title-icon">
                <i class="el-icon-circle-plus-outline" style="font-size: 16px;"></i>
              </div>
              <div v-else class="title-icon">
                <i class="el-icon-remove-outline" style="font-size: 16px;"></i>
              </div>
              <div class="title-text" style="font-size: 18px;">
                {{ item1.title }}
              </div>
            </div>
            <transition name="slide-up1">
              <div class="study-body" v-show="item1.visible">
                <div class="study-item" v-for="(chapter, chapterIndex) in item1.cate_childs" :key="chapterIndex"
                  style="margin-left: 70px;" @click.stop="setnot()">
                  <div class="name" :title="chapter.title">{{ chapter.title }}</div>
                  <div class="progress">
                    <div class="progress-title">练习进度</div>
                    <div class="progress-bar">
                      <Progress :percent="chapter.percent" hide-info :stroke-width="8"
                        :stroke-color="['#27a4ff', '#227efa']" />
                    </div>
                    <div class="progress-text">
                      {{ chapter.cont }}/{{ chapter.totality }}
                    </div>
                  </div>
                  <div class="action">
                    <router-link :to="{
                        name: 'Paper',
                        params: { id: chapter.id},
                        query: { cid: chapter.category_id, type_id: chapter.type_id }
                      }"><Button type="primary" shape="circle" long>开始练习</Button></router-link>
                      <router-link :to="{
                        name: 'WrongBook',
                        params: { sid: chapter.id },
                        query: { cid: chapter.category_id }
                        }">
                        <Button class="error-btn" type="default" shape="circle" long>错题：{{chapter.error_count?chapter.error_count:0}}</Button>
                      </router-link>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div v-else>
            <div class="study-body">
              <div class="study-item" style="margin-left: 40px;">
                <div class="name" :title="item1.title">{{ item1.title }}</div>
                <div class="progress">
                  <div class="progress-title">练习进度</div>
                  <div class="progress-bar">
                    <Progress :percent="item1.percent" hide-info :stroke-width="8"
                      :stroke-color="['#27a4ff', '#227efa']" />
                  </div>
                  <div class="progress-text">
                    {{ item1.cont }}/{{ item1.totality }}
                  </div>
                </div>
                <div class="action">
                  <router-link :to="{
                      name: 'Paper',
                      params: { id: item1.id},
                      query: { cid: item1.category_id, type_id: item1.type_id }
                    }"><Button type="primary" shape="circle" long>开始练习</Button></router-link>
                    <router-link :to="{
                      name: 'WrongBook',
                      params: { sid: item1.id },
                      query: { cid: item1.category_id }
                      }">
                      <Button class="error-btn" type="default" shape="circle" long>错题：{{item1.error_count?item1.error_count:0}}</Button>
                    </router-link>
                </div>
              </div>
            </div>
          </div>

        </div>
      </transition-group>
    </TimelineItem>
  </Timeline>
</template>
<script>
  export default {
    props: {
      subjectList: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        catalogList: [],
      };
    },
    mounted() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    methods: {
      getData() {
        this.catalogList = this.subjectList;
        this.catalogList.forEach((item, index) => {
          if (index === 0) {
            this.$set(item, "visible", true);
          } else {
            this.$set(item, "visible", false);
          }
          if (item.cate_childs.length > 0) {
            item.cate_childs.forEach((item1, index1) => {
              if (index1 === 0) {
                this.$set(item1, "visible", true);
              } else {
                this.$set(item1, "visible", false);
              }
              if (item1.cate_childs.length > 0) {
                item1.cate_childs.forEach((chapter, chapterIndex) => {
                  let percent = 0;
                  if (chapter.cont > chapter.totality) {
                    percent = 100;
                  } else if (chapter.totality > 0) {
                    percent = parseInt(
                      (chapter.cont / chapter.totality) * 100
                    );
                  }
                  this.$set(chapter, "percent", percent);
                });
              }else{
                let percent = 0;
                if (item1.cont > item1.totality) {
                  percent = 100;
                } else if (item1.totality > 0) {
                  percent = parseInt(
                    (item1.cont / item1.totality) * 100
                  );
                }
                this.$set(item1, "percent", percent);
              }
            })
          }else{
            let percent = 0;
            if (item.cont > item.totality) {
              percent = 100;
            } else if (item.totality > 0) {
              percent = parseInt(
                (item.cont / item.totality) * 100
              );
            }
            this.$set(item, "percent", percent);
          }
        });
      },
      setVisible(item) {
        item.visible = !item.visible;
      },
      setnot(){
        return false;
      }
    },
  };
</script>
<style lang="less" scoped>
  .study-wrap {
    padding: 0 20px;

    .item-dot {
      width: 15px;
      height: 15px;
      border-radius: 15px;
      border: 1px solid #ddd;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      span {
        width: 7px;
        height: 7px;
        border-radius: 7px;
        background: #eee;
      }
    }

    /deep/.ivu-timeline-item-tail {
      border: 1px dashed #ddd;
    }
  }

  .study-title {
    margin-top: -6px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    cursor: pointer;

    .title-icon {
      margin-right: 16px;
    }

    .title-text {
      font-size: 20px;
    }

    .title-text1 {
      font-size: 18px;
      width: 350px;
      margin-right:30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .study-body {
    .study-item {
      display: flex;
      align-items: center;
      border-bottom: 1px dashed #ddd;
      margin-left: 40px;
      padding: 16px 0;

      .name {
        width: 340px;
        font-size: 16px;
        color: #666;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .progress {
        flex: 1;
        display: flex;
        align-items: center;

        &-title {
          font-size: 14px;
          color: #666;
          margin-right: 10px;
        }

        &-bar {
          width: 150px;
          margin-right: 10px;
        }

        &-text {
          flex: 1;
          font-size: 16px;
          color: #666;
        }
      }

      .action {
        // width: 100px;
        a{
          display: inline-block;
        }
        .error-btn{
          width: 100px;
          padding:0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mall/study/ChapterPractice.vue